import { Box, Heading } from '@stenajs-webui/core';
import type { FC } from 'react';

export interface BookingDetailsSectionHeaderProps {
  title: string;
}
export const BookingDetailsSectionHeader: FC<BookingDetailsSectionHeaderProps> = ({ title }) => (
  <Box indent={3}>
    <Heading variant={'h3'}>{title}</Heading>
  </Box>
);
